import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Icon, ICONS, Loader, Typography } from '@thinknet-gmbh/platform-common-ui';

import { useCountProcessWidgetTasks } from 'src/hooks/process-tasks/count-widget-process-tasks.hook';

import { ROUTES } from '../../../../components/app/app-routes.constants';
import {
  WidgetContainer,
  TaskWidgetCard,
  TaskWidgetNumber,
  TaskWidgetCardDescription,
  TaskWidgetButton,
} from './tasks-widget.styles';


const TasksWidget = () => {
  const { t } = useTranslation(['dashboard']);
  const navigate = useNavigate();

  const { loading, tasks } = useCountProcessWidgetTasks();

  const handleNavigate = () => navigate(ROUTES.taskManager);

  if (loading) {
    return <Loader />;
  }

  return (
    <WidgetContainer>
      <TaskWidgetCard>
        <Typography weight={'bold'}>{t('taskWidgets.overdue.title')}</Typography>
        <TaskWidgetNumber>{tasks?.overdue || 0}</TaskWidgetNumber>
        <TaskWidgetCardDescription>
          {t('taskWidgets.overdue.description')}
        </TaskWidgetCardDescription>
        <Icon icon={ICONS.taskOverdue} rightMargin={false} />
        <TaskWidgetButton onClick={handleNavigate}>
          {t('taskWidgets.overdue.button')}
        </TaskWidgetButton>
      </TaskWidgetCard>
      <TaskWidgetCard>
        <Typography weight={'bold'}>{t('taskWidgets.open.title')}</Typography>
        <TaskWidgetNumber>{tasks?.open || 0}</TaskWidgetNumber>
        <TaskWidgetCardDescription>{t('taskWidgets.open.description')}</TaskWidgetCardDescription>
        <Icon icon={ICONS.taskOpen} rightMargin={false} />
        <TaskWidgetButton isOpen onClick={handleNavigate}>
          {t('taskWidgets.overdue.button')}
        </TaskWidgetButton>
      </TaskWidgetCard>
    </WidgetContainer>
  );
};

export default TasksWidget;
